// extracted by mini-css-extract-plugin
export default {"page":"style_page__JVyKN","desktop":"style_desktop__cT-3i","content":"style_content__bO-Yl"};